export const mainColorStyleElement = document.createElement('style');
export const brandColorStyleElement = document.createElement('style');
//# sourceMappingURL=theme-elements.js.map